import React from 'react'
import Loader from '../loaders/loader.component'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Creators as SiteCreators } from '../../ducks/site/site'

class AsyncRootComponent extends React.PureComponent {
	constructor(props) {
		super(props)

		this.state = {
			Component: null
		}
	}

	componentWillMount() {
		if (!this.state.Component) {
			const { moduleProvider, rendering, rendered } = this.props
			rendering()
			this.setState({ Component: moduleProvider().ModuleRootComponent })
			rendered()
		}
	}

	render() {
		const { Component } = this.state
		return Component ? (
			<Component />
		) : (
			<Loader transparent showLoader={true} />
		)
	}
}

const mapStoreToProps = store => {
	const { site } = store
	return {
		...site
	}
}

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			...SiteCreators
		},
		dispatch
	)

const AsyncComponent = connect(
	mapStoreToProps,
	mapDispatchToProps
)(AsyncRootComponent)

export default AsyncComponent
